import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  product: {
    id: null,
    title: "",
    price: "",
    imgUrl: null,
    idCategory: "",
    qty: null,
    satuan: "",
    variationList: [],
    addOnList: [],
  },
};

export const productSlice = createSlice({
  name: "product management",
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setProduct: (state, action) => {
      state.product.id = action.payload.id;
      state.product.title = action.payload.title;
      state.product.price = action.payload.price;
      state.product.imgUrl = action.payload.imgUrl;
      state.product.idCategory = action.payload.idCategory;
      state.product.qty = action.payload.qty;
      state.product.satuan = action.payload.satuan;
      state.product.variationList = action.payload.variationList;
      state.product.addOnList = action.payload.addOnList;
    },
  },
});

export const { setProducts, setProduct } = productSlice.actions;

export default productSlice.reducer;
